export const ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
export const ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
export const ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
export const ADD_TRANSPORT = 'ADD_TRANSPORT';
export const UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
export const CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
export const LOAD_PROPOSAL = 'LOAD_PROPOSAL';
export const FETCH_PROPOSALS = 'FETCH_PROPOSALS';
export const FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
export const FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
export const REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
export const SET_PROPOSALS = 'SET_PROPOSALS';
export const SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
export const UPDATE_INSURANCES = 'UPDATE_INSURANCES';
export const DELETE_INSURANCES = 'DELETE_INSURANCES';
export const PREPARE_BE = 'PREPARE_BE';
export const DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
export const FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
export const SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_PROMO_CODE_FAILURE_STATUS = 'failure';
export const SET_PROMO_CODE_SUCCESS_STATUS = 'success';
export const UPDATE_SERVICES = 'UPDATE_SERVICES';
export const ADD_SERVICE = 'ADD_SERVICE';
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
export const PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
export const PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
